import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button, IconButton, InputAdornment } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { TextField } from "@mui/material";
import blogFetch from "../../axios/config";
import { IModalAddGroupProps, IAddGroup } from "./GroupPermissionInterfaces";
import { getIdCompany } from "../../utils/constantes";
import language from "../../nls/language.json";
import Context from "../../context/Context";

const ModalAddGroup: React.FC<IModalAddGroupProps> = ({
  open,
  onClose,
  getGroup,
}) => {
  const [data, setData] = useState("");
  const [groupDescription, setGroupDescription] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const {
    selectedCountry
  } = useContext(Context);

  const addGroup = async () => {
    setLoading(true);
    try {
      const addGroup: IAddGroup = {
        group_CompanyId: getIdCompany(),
        group_description: groupDescription,
      };

      const response = await blogFetch.post(`/Group`, addGroup);
      const data = response.data;
      setTimeout(() => {
        setLoading(false);
      }, 500);
      await getGroup();
      onClose();
      return data;
    } catch (error) {
      console.error(error);
      setTimeout(() => {
        setLoading(false);
      }, 500);

      throw error;
    }
  };

  return (
    <Modal show={open} onHide={onClose}>  
      <Modal.Header closeButton>  
        <Modal.Title>  
        {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.adicionarGrupo.title}
          {data}
        </Modal.Title>  
      </Modal.Header>  
      <Modal.Body>  
        <div>  
          <TextField  
            className="mb-3"  
            id="outlined-basic"  
            label="Descrição"  
            variant="outlined"  
            size="small"  
            fullWidth  
            name="Descrição"  
            value={groupDescription}  
            onChange={(event) => setGroupDescription(event.target.value)}  
            sx={{ backgroundColor: "white", borderRadius: "5px" }}  
          />  
        </div>  
      </Modal.Body>  
      <Modal.Footer style={{ display: "flex", gap: 50 }}>  
        <Button variant="text" onClick={onClose}>  
        {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.adicionarGrupo.btnCancelar}  
        </Button>  
        {loading ? (  
          <LoadingButton loading variant="outlined">  
            Enviar
          </LoadingButton>  
        ) : (  
          <Button variant="contained" onClick={addGroup}>  
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.adicionarGrupo.btnSalvar}  
          </Button>  
        )}  
      </Modal.Footer>  
    </Modal> 
  );
};

export default ModalAddGroup;
